import React from "react";
import Box from "@mui/material/Box";
import { ReactComponent as EmptyComment } from "../../../../assets/images/KnowledgeBase/empty-comment-icon.svg";

const EmptyCommentsState = () => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "60px 0",
            }}
        >
            <EmptyComment style={{ marginBottom: "20px" }} />
            <Box
                sx={{
                    color: "#405261",
                    fontFamily: "Inter",
                    fontSize: "18px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "34px",
                    textAlign: "center",
                }}
            >
                No comments yet. Be the first to share your thoughts!
            </Box>
        </Box>
    );
};

export default EmptyCommentsState;
